(function () {
  'use strict';

  var settings = document.getElementById('ThemarLanguageSettings');
  if (!settings) return;
  var config;
  try { config = JSON.parse(settings.textContent); } catch (error) { return; }
  var languages = Array.isArray(config.languages) ? config.languages : [];
  if (languages.length < 2 || config.designMode || (window.Shopify && window.Shopify.designMode)) return;

  var key = 'themar_language_preference_v1';
  var current = String(config.currentLanguage || '').toLowerCase();

  function match(value) {
    if (typeof value !== 'string') return null;
    var code = value.toLowerCase().replace(/_/g, '-');
    var exact = languages.find(function (language) { return language.code.toLowerCase() === code; });
    if (exact) return exact;
    var base = code.split('-')[0];
    return languages.find(function (language) { return language.code.toLowerCase() === base; }) || null;
  }

  function readPreference() {
    var language;
    try { language = match(window.localStorage.getItem(key)); } catch (error) { /* Cookies still work. */ }
    if (language) return language;
    try {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i += 1) {
        var item = cookies[i].trim();
        if (item.indexOf(key + '=') === 0) return match(decodeURIComponent(item.slice(key.length + 1)));
      }
    } catch (error) { /* A blocked storage area must not break navigation. */ }
    return null;
  }

  function remember(value) {
    var language = match(value);
    if (!language) return;
    try { window.localStorage.setItem(key, language.code); } catch (error) { /* Optional persistence. */ }
    try {
      document.cookie = key + '=' + encodeURIComponent(language.code) + '; Max-Age=31536000; Path=/; SameSite=Lax' + (window.location.protocol === 'https:' ? '; Secure' : '');
    } catch (error) { /* Keep the native Shopify language form working. */ }
  }

  function localizationForm(target) {
    if (!target || typeof target.closest !== 'function') return null;
    var form = target.closest('form');
    if (!form) return null;
    var type = form.querySelector('input[name="form_type"]');
    return type && type.value === 'localization' ? form : null;
  }

  function keepReturnTo(form) {
    var input = form.querySelector('input[name="return_to"]');
    if (input) input.value = window.location.pathname + window.location.search + window.location.hash;
  }

  // Capture before native theme handlers submit the footer form directly.
  document.addEventListener('change', function (event) {
    var form = localizationForm(event.target);
    if (!form) return;
    var input = event.target;
    if (input.name !== 'language_code' && input.name !== 'locale_code') input = input.previousElementSibling;
    if (!input || (input.name !== 'language_code' && input.name !== 'locale_code')) return;
    var value = event.detail && event.detail.selectedValue !== undefined ? event.detail.selectedValue : input.value;
    if (!match(value)) return;
    remember(value);
    keepReturnTo(form);
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target && typeof event.target.closest === 'function' ? event.target.closest('button[name="language_code"], input[type="submit"][name="language_code"]') : null;
    var form = localizationForm(button);
    if (!form || button.disabled || !match(button.value)) return;
    remember(button.value);
    keepReturnTo(form);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = localizationForm(event.target);
    if (!form) return;
    var input = event.submitter;
    if (!input || (input.name !== 'language_code' && input.name !== 'locale_code')) input = form.querySelector('input[name="language_code"], input[name="locale_code"], select[name="language_code"], select[name="locale_code"]');
    if (input && match(input.value)) remember(input.value);
    keepReturnTo(form);
  }, true);

  // An explicitly localized link keeps its intended language and SEO destination.
  var pathname = window.location.pathname;
  var explicitLanguage = languages.some(function (language) {
    var root = String(language.root || '/').replace(/\/$/, '');
    return root && (pathname === root || pathname.indexOf(root + '/') === 0);
  });
  if (explicitLanguage || /(?:bot|crawler|spider|lighthouse|pagespeed)/i.test(navigator.userAgent || '')) return;
  if (/^\/(?:account|checkouts?|challenge|password)(?:\/|$)/.test(pathname)) return;

  var selected = readPreference();
  var browserLanguages = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
  if (!selected) {
    for (var i = 0; i < browserLanguages.length; i += 1) {
      selected = match(browserLanguages[i]);
      if (selected) break;
    }
  }
  if (!selected) selected = languages.find(function (language) { return language.primary; }) || match(current) || languages[0];
  remember(selected.code);
  if (selected.code.toLowerCase() === current) return;
  var root = String(selected.root || '/').replace(/\/$/, '');
  // Locale roots come from Shopify, never from visitor-controlled storage.
  if (root && (root.charAt(0) !== '/' || root.indexOf('//') === 0)) return;
  var destination = (pathname === '/' ? (root || '/') : root + pathname) + window.location.search + window.location.hash;
  if (destination !== pathname + window.location.search + window.location.hash) window.location.replace(destination);
}());
